import { LoadablePaint } from '@confluence/loadable';

export const BlogPostsSSRExtensionHandler = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-BlogPostsSSRExtensionHandler" */ '../src/BlogPostsSSRExtensionHandler.tsx'
			)
		).BlogPostsSSRExtensionHandler,
});
